import React, { useState, useEffect } from "react";
import "./index.css";
import SubscriptionModal from "../Subscription/components/SubscriptionModal";
import { useSubscription } from "../../context/subscriptionContext";
import { useHistory } from "react-router-dom";
import isSubscriptionActive from "utils/isSubscriptionActive";
import Authentication from "services/Authentication";
import ProductCard from "./components/ProductCard";

let auth = new Authentication();

const Dashboard = ({ enlarged }) => {
  const history = useHistory();
  const [selectedEssentialOptimization, setSelectedEssentialOptimization] =
    useState("");
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);
  const subscription = useSubscription();

  const jwtPayload = auth.getAccessTokenPayload();
  const { subscribedProduct } = subscription;

  useEffect(() => {
    if (isSubscriptionActive(subscription) || jwtPayload.userTypeId === 1) {
      history.push(selectedEssentialOptimization);
    } else {
      setShowSubscriptionModal(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedEssentialOptimization]);

  const products = [
    {
      id: "1",
      name: "SenseNC Feeds Standard (300 operations)",
      description: "Autonomous Toolpath Optimization from NX CAM",
      price: "$1247",
      image: "assets/images/ProductionMachinesLaptop.png",
      isProminent: true,
      onClick: () => setShowSubscriptionModal(true),
    },
    {
      id: "2",
      name: "SenseNC Feeds Additional (200 operations)",
      description: "Autonomous Toolpath Optimization from NX CAM",
      price: "£997",
      image: "assets/images/ProductionMachinesLaptop.png",
      isProminent: true,
      onClick: () => setShowSubscriptionModal(true),
    },
    {
      id: "3",
      name: "Feed Rate Optimizer",
      description:
        "Feed and Speed Optimization for straight cuts from your browser",
      price: "FREE",
      image: "assets/images/slotting.png",
      onClick: () => setSelectedEssentialOptimization("/digi-basic"),
    },
    {
      id: "4",
      name: "Spindle Speed Optimizer",
      description:
        "Built for adventure with precision GPS, extended battery life, and rugged titanium case.",
      price: "£5000",
      isProminent: true,
      image: "assets/images/SpindleSpeedOptimizer.png",
      onClick: () => setSelectedEssentialOptimization("/digi-stability"),
    },
  ];

  return (
    <>
      <section style={{ padding: "5rem 0" }}>
        <div className="container">
          <div className="row">
            <div
              className="col-12 text-center"
              style={{ marginBottom: "4rem" }}
            >
              <h2
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  color: "var(--foreground)",
                  marginBottom: "1rem",
                }}
              >
                Featured Products
              </h2>
              <p
                style={{
                  fontSize: "1.25rem",
                  color: "var(--muted-foreground)",
                  maxWidth: "42rem",
                  margin: "0 auto",
                }}
              >
                Discover our carefully curated selection of premium tech
                products designed to enhance your digital experience.
              </p>
            </div>
          </div>

          <div className="row">
            {products.map((product) => (
              <div key={product.id} className="col-lg-6 col-md-6 col-12">
                <ProductCard
                  {...product}
                  subscribedProduct={subscribedProduct}
                  jwtPayload={jwtPayload}
                />
              </div>
            ))}
          </div>
        </div>
      </section>
      {showSubscriptionModal && (
        <SubscriptionModal
          showSubscriptionModal={showSubscriptionModal}
          setShowSubscriptionModal={setShowSubscriptionModal}
        />
      )}
    </>
  );
};

export default Dashboard;
